// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://erticlijceutpetbahff.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVydGljbGlqY2V1dHBldGJhaGZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM3MDMwMDMsImV4cCI6MjA1OTI3OTAwM30.OC_KiMmfpjul1h9DWdPbTYGATNymz0u_cdbWX0bzJJE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);